<template>
  <div
    v-if="label && count"
    class="count-wrapper mb-1"
  >
    <v-skeleton-loader
      v-if="isLoading"
      type="text"
      width="100px"
    />
    <InsightDatasetCount
      v-else
      :label="label"
      :count="count"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';
import { startCase } from 'lodash-es';
import { useDatasetCounts } from '@/stores/insights/datasetCounts';
import InsightDatasetCount from '@/components/insights/InsightsDatasetCount.vue';
import { useActionableInsights } from '@/stores/insights/actionableInsights';

defineProps({
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const route = useRoute();

const datasetCountsStore = useDatasetCounts();
const { count } = storeToRefs(datasetCountsStore);
const { documentType } = storeToRefs(useActionableInsights());

const label = computed(() => ({
  'demographic-survey-report': 'Candidates',
  'overall-report': 'Candidates',
  'inbound-report': 'Candidates',
  'outbound-report': 'Candidates',
  'gender-report': 'Candidates',
  'drop-off': 'Candidates',
  'pass-through': 'Candidates',
  'hiring-report': 'Candidates',
  'weekly-snapshot': 'Job Posts',
  'language-snapshot': 'Job Posts',
  'content-snapshot': 'Job Posts',
  'employer-brand-report': `Non-Brand Compliant Live ${startCase(documentType.value)}s`,
  'job-performance-report': 'Unoptimized Live Jobs',
  'compliance-report': 'Non-Compliant Live Jobs',
}[route.name]));
</script>

<style lang="less" scoped>
.v-skeleton-loader {
  background: transparent;

  :deep(.v-skeleton-loader__text) {
    margin: 0;
  }
}

.count-wrapper {
  justify-self: flex-end;
}
</style>
